import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    width: 100%;
    padding: ${theme.v3.spacing.xxs};
    flex-direction: column;
    align-items: flex-start;
    gap: ${theme.v3.spacing.xxs};
    border-radius: ${theme.v3.border.radius.md};
    background: ${theme.v3.colors.neutral[100]};

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      max-width: 100%;
    }
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    color: ${theme.v3.colors.neutral[20]};
    font-size: ${theme.v3.font.sizes.medium};
    font-style: normal;
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;
  `}
`;

export const Description = styled.div`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[30]};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v3.font.sizes.medium};
    font-style: normal;
    font-weight: ${theme.v3.font.weights.regular};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;
    padding: 0 0 ${theme.v3.spacing.nano};

    span {
      color: #4A4A4A;
    }
  `}
`;

export const FaqItemsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${theme.v3.spacing.xxxs};

    #accordion-header div {
      font-family: ${theme.v2.font.family.primary};
      font-size: ${theme.v3.font.sizes.medium};
    }
  `}
`;
